import React from 'react';
import UserProfileBox from './UserProfileBox';
import SidebarNavigation from './SidebarNavigation';
import {logout} from '../../client/helpers/AuthHelper';
import { path_tier3} from '../../routes/Pathnames';
import {Link} from 'react-router-dom';

const LeftSidebar = () => {
    return(
        <aside className="left-sidebar">
            <div className="scroll-sidebar">
                <UserProfileBox/>
                <SidebarNavigation/>
            </div>
            <div className="sidebar-footer">
                <Link to="" className="link" data-toggle="tooltip" title="Settings">
                    <i className="fas fa-user-cog" aria-hidden="true"></i>
                </Link>
                <Link to={path_tier3} className="link" data-toggle="tooltip" title="Email">
                    <i className="fas fa-envelope"></i>
                </Link>
                <button type="button" onClick={logout} className="link" data-toggle="tooltip" title="Logout">
                    <i className="fas fa-power-off"></i>
                </button>
            </div>
        </aside>
    )
} 

export default LeftSidebar;
